// src/components/ResourceConfirm.jsx
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../../firebase';
import { Link } from 'react-router-dom';
import { useTranslatedText } from '../i18n/useTranslatedText.js';
import './ResourceConfirm.css';

const ResourceConfirm = () => {
  const [pendingResources, setPendingResources] = useState([]);
  const pageTitle = useTranslatedText('Bekleyen Kaynak Onayları');
  const byText = useTranslatedText('Yazar:');
  const onText = useTranslatedText('Tarih:');

  useEffect(() => {
    const fetchPendingResources = async () => {
      try {
        const q = query(collection(db, 'resources'), where('status', '==', 'pending'));
        const snapshot = await getDocs(q);
        const pendingList = snapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
        setPendingResources(pendingList);
      } catch (error) {
        console.error("Error fetching pending resources:", error);
      }
    };

    fetchPendingResources();
  }, []);

  return (
    <div className="resource-confirmation">
      <h2>{pageTitle}</h2>
      <div className="pending-resources-grid">
        {pendingResources.map(resource => (
          <Link key={resource.id} to={`/resource-onayla/${resource.id}`} className="pending-resource-card">
            <div className="resource-image">
              <img 
                src={resource.thumbnailUrl} 
                alt={resource.title} 
                loading="lazy" 
              />
            </div>
            <div className="resource-details">
              <h3>{resource.title}</h3>
              <p>{byText} {resource.author} {onText} {resource.publishDate}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ResourceConfirm;
